import collectionModule from './modules/collection'

const module = collectionModule('content')

export default module
